import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Formulario, FiltroExt } from 'src/app/models';
import { ConsultaService } from '../../../services/consulta.service';
import { EnvService } from '../../../../environments/env.service';

@Component({
    selector: 'app-consulta-estado',
    templateUrl: 'consultaestado.template.html',
    styleUrls: ['consultaestado.component.scss'],
    providers: [ConsultaService]
})
export class ConsultaEstadoComponent implements OnInit {

    tipoGrupo: string;
    formulario: Formulario;
    loading = false;
    siteKey: string;
    filtro: FiltroExt;

    constructor(private env: EnvService,
                private toastr: ToastrService,
                private service: ConsultaService
                ) {
    this.siteKey = env.APP_RECAPTCHA_KEY;
    this.filtro = new FiltroExt();
    }

    ngOnInit() {

    }

    OnBuscar(): void {
      if (this.filtro.NroDocumento === undefined || this.filtro.NroDocumento == null) {
        this.formulario = null;
        this.toastr.warning('Debe ingresar un Número de DNI.', 'Acción inválida');
        return;
      }
      this.realizarConsulta();
    }

    resolved(captchaResponse: string) {
      this.filtro.captcha = captchaResponse;
    }

    realizarConsulta() {
      this.formulario = null;
      this.loading = true;
      this.service.consultarEstado(this.filtro)
      .subscribe(
        response => {
          grecaptcha.reset();
          if (response.Resultado === 1) {
            this.formulario = response.data as Formulario;
            if (this.formulario.NombreTipoGrupo === 'GRUPO FAMILIAR') {
              this.tipoGrupo = 'GF';
            } else {
              this.tipoGrupo = 'GND';
            }
            this.loading = false;
          } else {
            this.formulario = null;
            this.loading = false;
            this.toastr.warning(response.Error, 'Acción inválida');
          }
        },
        error => {
          this.loading = false;
          this.toastr.error(error, 'Acción inválida');
        }
      );
    }
}
